function createObject() {
  let example = {
    id: "LBST_ZV_Gruppen_Zaehlprinzipien_alt_3",
    showGroupNames: true,
    checkAfterHowManyItems: 1,
    checkAfterExactItemCount: false,
    workOrder: `In der nachfolgenden Abbildung werden einige Zählprinzipien oder ihre Verletzung dargestellt. Bestimmen Sie, welches Zählprinzip erfüllt oder verletzt wird oder zu welchem keine Aussage getroffen werden kann.`,
    workOrderImage: require("@/assets/zv/Gruppen/zp/aufgabe_alt_3.png"),
    possibleCategories: [
      {
        id: 1,
        name: "Erfüllt",
      },
      {
        id: 2,
        name: "Nicht erfüllt",
      },
      {
        id: 3,
        name: "Nicht erkennbar",
      },
    ],
    elements: [
      {
        id: 1,
        image: require("@/assets/zv/Gruppen/zp/01.png"),
        category: 1,
        flex: 3,
      },
      {
        id: 2,
        image: require("@/assets/zv/Gruppen/zp/02.png"),
        category: 3,
        flex: 3,
      },
      {
        id: 3,
        image: require("@/assets/zv/Gruppen/zp/03.png"),
        category: 2,
        flex: 3,
      },
      {
        id: 4,
        image: require("@/assets/zv/Gruppen/zp/04.png"),
        category: 1,
        flex: 3,
      },
      {
        id: 5,
        image: require("@/assets/zv/Gruppen/zp/05.png"),
        category: 2,
        flex: 3,
      },
    ],
  };

  const einerfuellt =
    "Eines der ausgewählten Zählprinzipien wird in der Abbildung angesprochen. Welches weitere Zählprinzip ist erfüllt? ";

  const zweierfuellt =
    "Richtig! Das Abstraktionsprinzip und das Prinzip der Irrelevanz der Reihenfolge sind hier erfüllt. ";

  const einnichterfuellt =
    "Eines der ausgewählten Zählprinzipien wird in der Abbildung nicht angesprochen. Welches weitere Zählprinzip ist nicht erfüllt? ";

  const zweinichterfuellt =
    "Korrekt! Das Prinzip der stabilen Reihenfolge besagt, dass die Zahlwörter stets in derselben Reihenfolge durchlaufen werden. „Sie“ und „ben“ werden nicht getrennt. Da nicht jedem Zahlwort genau ein Plättchen zugeordnet wurde, ist das Eins-Eins-Prinzip nicht erfüllt. ";

  const einnichterkennbar =
    "Das Kardinalzahlprinzip ist nicht erkennbar, da nicht nach der Angabe der Menge der Plättchen gefragt wurde. ";

  example.responses = [
    {
      id: "200",
      category: example.possibleCategories[0],
      text: zweierfuellt,
    },
    {
      id: "020",
      category: example.possibleCategories[1],
      text: zweinichterfuellt,
    },
    {
      id: "001",
      category: example.possibleCategories[2],
      text: einnichterkennbar,
    },
    {
      id: "010",
      text: einnichterfuellt,
    },
    {
      id: "100",
      text: einerfuellt,
    },
    {
      id: "221",
      text: zweierfuellt + zweinichterfuellt + einnichterkennbar,
    },
    {
      id: "220",
      text: zweierfuellt + zweinichterfuellt,
    },
    {
      id: "211",
      text: zweierfuellt + einnichterfuellt + einnichterkennbar,
    },
    {
      id: "210",
      text: zweierfuellt + einnichterfuellt,
    },
    {
      id: "201",
      text: zweierfuellt + einnichterkennbar,
    },
    {
      id: "121",
      text: einerfuellt + zweinichterfuellt + einnichterkennbar,
    },
    {
      id: "120",
      text: einerfuellt + zweinichterfuellt,
    },
    {
      id: "021",
      text: zweinichterfuellt + einnichterkennbar,
    },
    {
      id: "111",
      text: einerfuellt + einnichterfuellt + einnichterkennbar,
    },
    {
      id: "011",
      text: einnichterfuellt + einnichterkennbar,
    },
    {
      id: "101",
      text: einerfuellt + einnichterkennbar,
    },
    {
      id: "110",
      text: einerfuellt + einnichterfuellt,
    },
  ];

  return example;
}

export default createObject();
